export const SET_AUTH = "auth/SET_AUTH";
export const CLEAR_AUTH = "auth/CLEAR_AUTH";

export const setAuth = (username, groups, permissions) => ({
  type: SET_AUTH,
  payload: { username, groups: groups || [], permissions: permissions || [] },
});

// TODO: Develop logout later
export const clearAuth = () => ({ type: CLEAR_AUTH });
